<template>
    <div class="content">
    <main>
        <section>
            <h2>Preise {{year}}</h2>
            <p>Übernachtung mit reichhaltigem, erweitertem Frühstück (Produkte vom Bauernhof, hausgemachte Marmeladen, etc.)</p>
            <table class="preise">
                <caption>Aktuelle Preise {{year}}</caption>
                <tr><th>eine Übernachtung mit Frühstück</th><td>{{adultBreakfast}}</td></tr>
                <tr><th>eine Übernachtung ohne Frühstück</th><td>{{adultNoBreakfast}}</td></tr>
                <tr><th>Kurzaufenthaltszuschlag</th><td>{{shortTermStay}}</td></tr>
            </table>

            <table class="preise">
                <caption>Kinderermäßigung (im Zimmer der Eltern)</caption>
                <tr><th>0 - 6 Jahre gratis Übernachtung </th><td>{{children6}}</td></tr>
                <tr><th>7 - 10 Jahre </th><td>{{children10}}</td></tr>
                <tr><th>11 - 15 Jahre </th><td>{{children15}}</td></tr>
            </table>
        </section>
    </main>

    <aside>
        <section>
            <h2>Abholdienst von Wien</h2>
            <p>Wir bieten einen Gästeabholdienst an ({{pickUp}}). Ein Sammeltaxi holt Sie samstags direkt von Ihrem Zuhause ab und bringt Sie zu uns. Auch die Retourfahrten finden an Samstagen statt.</p>
        </section>
    </aside>
    </div>
</template>

<script>
    import {getAdult, getChildren, getPickUp, getShortTermStay, getYear} from "../services/priceService";

    export default {
        name: "Preise",
        computed: {
            year() { return getYear() },
            pickUp() { return getPickUp() },
            adultNoBreakfast() { return getAdult(false) },
            adultBreakfast() { return getAdult(true) },
            children6() { return getChildren(6) },
            children10() { return getChildren(10) },
            children15() { return getChildren(15) },
            shortTermStay() { return getShortTermStay() }
        }
    }
</script>

<style lang="scss" scoped>
table.preise {
    margin: 2em 0;
    border-collapse: collapse;


    & caption {
        text-align:left;
        font-size:1.2em;
        font-weight:bold;
        margin-bottom:.2em;
    }

    & th {
        width:20rem;
        padding:.2rem 0;
        font-weight: normal;
    }

    & td{
        width:10rem;
        text-align:right;
        padding:.2rem 0;
    }

    & tr {
        border-bottom: 1px solid gray;
    }
}

</style>